define('selectView',[
  'module',
  'marionette',
  'underscore',
  'inputView',
  'selectOptionView'
], function (
  Module,
  Marionette,
  _,
  InputView,
  SelectOptionView
) {
  'use strict';

  Module.exports = Marionette.CollectionView.extend({
    className: 'select-view ' + InputView.prototype.className,
    tagName: 'select',
    childView: SelectOptionView,

    attributes: function () {
      return _.extend({}, InputView.prototype.attributes.apply(this, arguments), {
        'disabled': this.options.allowFromSelection === false ? true : false
      });
    },

    events: {
      'change': 'onChange'
    },

    initialize: function() {
      if(this.collection.models.length > 0)
        this.collection.models[0].set('selected', true);
    },

    getValue: function () {
      return this.getSelected().get('id');
    },

    setValue: function (value) {
      this.setSelected(value);
    },

    setSelected: function(id) {
      this.$el.val(id);

      _.each(this.collection.models, function(model) {
        if(model.get('id') === id)
          model.set('selected', true);
        else
          model.set('selected', false);
      });
    },

    getSelected: function() {
      var selectdeModel = null;
      _.each(this.collection.models, function(model) {
        if(model.get('selected'))
          selectdeModel = model;
      });

      if(!selectdeModel)
        selectdeModel = this.collection.models[0];

      return selectdeModel;
    },

    onChange: function() {
      _.each(this.collection.models, _.bind(function(model) {
        if(model.get('id').toString() === this.$el.val())
          model.set('selected', true);
        else
          model.set('selected', false);
      }, this));

      this.trigger('change', this.getSelected());
    }
  }, InputView);
});
  
